// Support both Vite build-time env (dev) and runtime window.ENV (production Pages)
const ENV = typeof window !== 'undefined' && window.ENV ? window.ENV : import.meta.env;

// Production fallback values - Supabase anon key is public by design
const PROD_SUPABASE_URL = 'https://cjtiriwgybrmzysspjsy.supabase.co';
const PROD_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNqdGlyaXdneWJybXp5c3NwanN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyMTY1MTcsImV4cCI6MjA5Mjc5MjUxN30.VBosWuEPHOmGEL5aqLDuTLGplw4qMWbRP2_l5Y5ms4M';
const PROD_API_BASE_URL = 'https://foot-debrief-worker.dejavu-app.workers.dev';

export const SUPABASE_URL = ENV?.VITE_SUPABASE_URL || PROD_SUPABASE_URL;
export const SUPABASE_ANON_KEY = ENV?.VITE_SUPABASE_ANON_KEY || PROD_SUPABASE_ANON_KEY;
export const API_BASE_URL = ENV?.VITE_API_BASE_URL || PROD_API_BASE_URL;

// Nombre d'images extraites puis envoyées à l'analyse Ollama Cloud. 24 par
// défaut : assez dense pour couvrir les transitions tactiques d'un segment.
// Surchargeable via VITE_ANALYZE_FRAME_COUNT ; borné à [4, 24] côté client. Le
// Worker garde un plafond plus haut pour la rétrocompatibilité des anciens bundles.
function resolveFrameCount(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 24;
  return Math.min(24, Math.max(4, Math.round(n)));
}
export const ANALYZE_FRAME_COUNT = resolveFrameCount(ENV?.VITE_ANALYZE_FRAME_COUNT ?? 24);

// Synthèse vocale (TTS) : désactivée par défaut. Les providers (Cloudflare
// Inworld/MeloTTS, ElevenLabs, MiniMax) échouent tous en prod ; tant qu'aucun
// n'est fiable, on ne montre aucun lecteur côté UI et on n'appelle jamais
// /api/tts. Le code backend reste en place pour une réactivation future :
// passer VITE_TTS_ENABLED=true (accepte aussi "1"/"yes"/"on") suffit à le
// rétablir sans toucher au code.
export function resolveTTSEnabled(raw) {
  if (typeof raw === 'boolean') return raw;
  if (typeof raw !== 'string') return false;
  return /^(true|1|yes|on)$/i.test(raw.trim());
}
export const TTS_ENABLED = resolveTTSEnabled(ENV?.VITE_TTS_ENABLED ?? false);

export const APP_COLORS = {
  bg: '#f3f6f1',
  accent: '#0f5132',
  secondary: '#18794e',
  cardBg: '#ffffff',
  border: '#d8e1d8',
  text: '#101815',
  textMuted: '#5f6f68'
};

export const ROUTES = {
  LOGIN: '#/login',
  HOME: '#/home',
  UPLOAD: '#/upload',
  DEBRIEF: '#/debrief',
  PROFILE: '#/profile'
};
